import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../utils/GA';
import { initCookieConsent, trackPageView } from '../utils/cookieConsent';

/**
 * Invisible component that initialises cookie consent on mount and tracks
 * SPA page views on route changes. Must be rendered inside a Router context.
 */
export default function AnalyticsTracker() {
  const location = useLocation();
  const didInitRef = useRef(false);
  const lastPathRef = useRef<string>('');

  // Initialise Cookie Consent once — guarded against SSR
  useEffect(() => {
    if (!didInitRef.current) {
      initCookieConsent();
      didInitRef.current = true;
    }
  }, []);

  // Track SPA route changes (pathname + search), include title
  useEffect(() => {
    const path = location.pathname + location.search;
    // Prevent duplicate sends in React 18 StrictMode during development
    if (import.meta.env.DEV && lastPathRef.current === path) {
      return;
    }
    lastPathRef.current = path;
    const title = typeof document !== 'undefined' ? document.title : undefined;
    logPageView(path, title);
    trackPageView(path, title);
  }, [location.pathname, location.search]);

  return null;
}
